import { unauthApi } from './unauth'; // adjust path to your unauth api file

export const applyAffiliateApi = unauthApi.injectEndpoints({
  endpoints: (builder) => ({
    applyAffiliate: builder.mutation({
      query: ({ payload }) => ({
        url: '/v2/sp/affiliate/apply',
        method: 'POST',
        body: payload,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useApplyAffiliateMutation } = applyAffiliateApi;